var Handlebars = require('/home/circleci/project/node_modules/handlebars/lib/index.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
  return "Country/Region/Territory";
  },"3":function(depth0,helpers,partials,data) {
  return "Country";
  },"5":function(depth0,helpers,partials,data) {
  var lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "    <option value=\""
    + escapeExpression(lambda((data && data.value), depth0))
    + "\">"
    + escapeExpression(lambda((data && data.text), depth0))
    + "</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "<option value=\"\">Choose ";
  stack1 = ((helpers.feature || (depth0 && depth0.feature) || helperMissing).call(depth0, "IHSCustomCountryLabel", {"name":"feature","hash":{},"fn":this.program(1, data),"inverse":this.program(3, data),"data":data}));
  if (stack1 != null) { buffer += stack1; }
  buffer += "...</option>\n";
  stack1 = ((helpers.getCountryList || (depth0 && depth0.getCountryList) || helperMissing).call(depth0, (depth0 != null ? depth0.countryExceptions : depth0), (depth0 != null ? depth0.eventCountries : depth0), (depth0 != null ? depth0.keyAsValue : depth0), {"name":"getCountryList","hash":{},"fn":this.program(5, data),"inverse":this.noop,"data":data}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});